import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "groups-container" }
const _hoisted_2 = { class: "groups-tab-bar" }
const _hoisted_3 = { class: "groups-tab-content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_GroupsListView = _resolveComponent("GroupsListView")!
  const _component_GroupSelections = _resolveComponent("GroupSelections")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        class: _normalizeClass(["groups-tab", { 'groups-tab--active': _ctx.activeTab === 'groups' }]),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.activeTab = 'groups'))
      }, _toDisplayString(_ctx.$t('Groups.Title')), 3),
      _createElementVNode("button", {
        class: _normalizeClass(["groups-tab", { 'groups-tab--active': _ctx.activeTab === 'groupselections' }]),
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.activeTab = 'groupselections'))
      }, _toDisplayString(_ctx.$t('Groups.GroupsSelections')), 3)
    ]),
    _createElementVNode("div", _hoisted_3, [
      (_ctx.activeTab === 'groups')
        ? (_openBlock(), _createBlock(_component_GroupsListView, { key: 0 }))
        : (_ctx.activeTab === 'groupselections')
          ? (_openBlock(), _createBlock(_component_GroupSelections, { key: 1 }))
          : _createCommentVNode("", true)
    ])
  ]))
}